<template>
    <div>
        <img class="song-cover rounded " :src="song.song_image" alt="">
        <div class="overlay">
            <div class="rounded"></div>
        </div>
        <div class="position-absolute song-info">
            <div class="d-flex justify-content-between align-items-baseline">
                <div>
                    <h5 class="text-neutral-25 song-name text-4 m-0 text-break">{{ song.song_name }}</h5>
                    <p class="text-neutral-200 text-3 text-break">{{ song.song_artist }}</p>
                    <p>
                        <i title="Not played yet" v-if="song.status == 0" class="fa-solid fa-clock text-warning"></i>
                        <i title="Already played" v-if="song.status == 1" class="fa-solid fa-circle-check text-success"></i>
                    </p>
                </div>
                <div>
                    <template v-if="role == 2">
                        <div class="btn-group">
                            <button type="button" class="btn dropdown-toggle text-white" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li><button v-if="song.status == 0" @click="markAs(song, 'played')" class="dropdown-item" type="button">Mark as played</button></li>
                                <li><button v-if="song.status == 1" @click="markAs(song, 'unplayed')" class="dropdown-item" type="button">Mark as unplayed</button></li>
                                <li><button @click="markAs(song, 'delete')" class="dropdown-item" type="button">Delete</button></li>
                            </ul>
                        </div>
                    </template>
                    <template v-else>
                        <button @click="cancelRequest(song)" type="button" class="btn text-danger p-1 lh-1"><i
                                class="fa-regular fa-circle-xmark"></i></button>
                    </template>
                </div>
            </div>
        </div>
        <p v-if="role == 2" class="text-neutral-25 position-absolute request-by text-3 pe-2">Requested by {{
            song.request_count
            }}
            attendee</p>
    </div>
</template>
<script scoped>
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';

export default ({
    props: {
        song: Object
    },
    setup() {
        const store = useStore();
        const role = computed(() => store.getters['user/getUserRole']);
        const route = useRoute();
        const toast = useToast();
        const eventId = route.params.eventId;
        const swal = inject('$swal');

        const cancelRequest = async (song) => {
            swal({
                title: 'Delete',
                text: 'Are you sure you want to proceed?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#6A04BA',
                confirmButtonText: 'Delete',
                showConfirmButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const body = {
                        song_id: song.song_id,
                        event_id: eventId,
                    };
                    const response = await store.dispatch('attendeeEvent/cancelSongRequest', body);
                    if (response.data.status) {
                        toast.success(response.data.msg);
                    } else {
                        toast.error(response.data.msg);
                    }
                }
            })
        }
        const markAs = async (song, markAs) => {
            const title = markAs == 'played' ? 'Mark as played!' : (markAs == 'Mark as unplayed' ? 'unplayed' : 'Delete!');
            const btnText = markAs == 'played' ? 'Mark as played!' : (markAs == 'Mark as unplayed' ? 'unplayed' : 'Delete!');
            const success = markAs == 'played' ? 1 : (markAs == 1 ? 'unplayed' : 0);
            swal({
                title: title,
                text: 'Are you sure you want to proceed?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: success ? '#6A04BA' : '#d33',
                cancelButtonColor: success ? '#d33' : '#6A04BA',
                confirmButtonText: btnText,
                showConfirmButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const body = {
                        song_id: song.song_id,
                        event_id: eventId,
                        mark_as: markAs,
                    };
                    const response = await store.dispatch('event/markAsSongRequest', body);
                    if (response.data.status) {
                        toast.success(response.data.msg);
                    } else {
                        toast.error(response.data.msg);
                    }
                }
            })
        }

        return {
            role,
            cancelRequest,
            markAs
        }
    }
})
</script>
<style scoped>
.overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 0.75rem;
}

.overlay>div {
    background: #000000b0;
    height: 100%;
}

.song-cover {
    width: 100%;
}

.song-info {
    top: 3%;
    left: 8%;
    right: 8%;
}

.request-by {
    bottom: 2%;
    left: 10%;
}
</style>
